import React from 'react';
import { Col, Form } from 'antd';
import { I18n } from '@aws-amplify/core';

import { useApplicationContext } from '@/context/v1/Application/context';
import { SectorSelect } from '@/components/ui/Inputs/SectorSelect';
import { useSectors } from '@/hooks/v1';

const { useFormInstance, useWatch } = Form;

export const Sectors: React.FC = () => {
	const form = useFormInstance();
	const { company, organization } = useApplicationContext();

	const companyId = useWatch('company_id', form);
	const sectorId = useWatch('sector_id', form);

	const {
		data: sectors,
		isLoading,
		isFetching,
		isError
	} = useSectors({
		organizationId: organization?.id,
		companyId: company?.id
	});

	function handleOnSectorSelect(id: string): void {
		form.setFieldValue(['sector_id'], id);
		form.setFieldValue(['line_id'], undefined);
		form.setFieldValue(['workstation_id'], undefined);
	}

	function handleOnClearSector(): void {
		form.setFieldValue(['sector_id'], undefined);
		form.setFieldValue(['line_id'], undefined);
		form.setFieldValue(['workstation_id'], undefined);
	}

	return (
		<Col xs={24}>
			<Form.Item name={['sector_id']} label={I18n.get('Sector')} labelCol={{ span: 24 }}>
				<SectorSelect
					sectors={sectors}
					sectorId={sectorId}
					loading={isFetching}
					allowCreation={false}
					fieldName="sector_id"
					handleClearSector={handleOnClearSector}
					handleSelectSector={handleOnSectorSelect}
					disabled={isLoading || isFetching || isError || !companyId}
				/>
			</Form.Item>
		</Col>
	);
};
